import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { TESTIDS } from "@/lib/site";
import { useReveal } from "@/lib/useReveal";

const FAQS = [
  {
    q: "¿Necesito experiencia musical?",
    a: "No. No necesitas saber cantar, tocar un instrumento ni tener formación musical. La música se utiliza como recurso terapéutico, no como una habilidad de desempeño.",
  },
  {
    q: "¿Las sesiones son en línea o presenciales?",
    a: "Ambas modalidades están disponibles, según lo que sea más cómodo y posible para ti.",
  },
  {
    q: "¿Cuánto dura una sesión?",
    a: "Cada sesión tiene una duración aproximada de 1 hora.",
  },
  {
    q: "¿Cómo sé si este espacio es para mí?",
    a: "Este espacio puede ser para ti si estás buscando un proceso terapéutico seguro, cálido y transparente, donde tus emociones puedan ser escuchadas, exploradas y acompañadas con sensibilidad.",
  },
  {
    q: "¿Qué ocurre durante una sesión de musicoterapia?",
    a: "Una sesión sigue la metodología IMMH: comienza con la identificación del problema, continúa con la exploración emocional a través de preguntas reflexivas clave, después un ejercicio de exploración emocional y, finalmente, un proceso de resignificación de la experiencia para aplicarlo en la vida real.",
  },
];

export default function FAQ() {
  const r = useReveal();
  return (
    <section
      id="preguntas"
      data-testid={TESTIDS.faq.section}
      className="relative py-24 md:py-32 bg-warm-beige/40"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className={`${r.className} text-center mb-12`}>
          <p className="text-[0.78rem] tracking-[0.22em] uppercase text-accent-magenta mb-4">
            Preguntas frecuentes
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-editorial-dark leading-tight">
            Antes de tu primer
            <span className="italic text-terracotta"> encuentro</span>.
          </h2>
          <p className="mt-4 text-editorial-gray max-w-xl mx-auto">
            Algunas dudas comunes que pueden acompañarte al inicio de un proceso terapéutico.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full space-y-3"
          data-testid={TESTIDS.faq.accordion}
        >
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              data-testid={TESTIDS.faq.item(i)}
              className="rounded-2xl bg-warm-white border border-dusty-rose/30 px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left font-serif text-[1.25rem] md:text-[1.35rem] text-editorial-dark hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-editorial-gray leading-relaxed text-[0.98rem] pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
